/* MCW yarn-heart likes (owner 2026-10-25). Buttons: snippets/mcw-like-button.liquid.
   Backend: n8n workflow "MCW Product Likes" (scripts/n8n-likes-workflow.mjs) - one like per product per
   visitor connection, real counts only. The visitor's own likes are remembered in localStorage.
   2026-10-27 (owner): likes double as a favorites list ("a step before the cart"):
   - window.mcwFavs = { ids(), count(), has() }, event "mcw:favs" on every change
   - header heart bubble [data-mcw-fav-count] (snippets/mcw-fav-header.liquid), page /pages/my-favorites
     (sections/mcw-favorites.liquid), small toast after a like
   - cross-device for logged-in customers via the cart attribute _mcw_favorites (Shopify keeps a customer's
     cart across devices) - no external service involved. The n8n API is used for the public like COUNTS only. */
(function () {
  if (window.__mcwLikes) return; window.__mcwLikes = true;
  var API = 'https://n8n.sunshine-group.de/webhook/';
  var counts = {}, liked = {};
  try { (JSON.parse(localStorage.getItem('mcw_liked') || '[]') || []).forEach(function (p) { liked[p] = 1; }); } catch (e) {}
  function ids() { return Object.keys(liked); }
  function saveLiked() {
    try { localStorage.setItem('mcw_liked', JSON.stringify(ids())); } catch (e) {}
    updateBadges();
    try { document.dispatchEvent(new CustomEvent('mcw:favs', { detail: { ids: ids() } })); } catch (e) {}
  }
  window.mcwFavs = { ids: ids, count: function () { return ids().length; }, has: function (pid) { return !!liked[String(pid)]; } };

  function updateBadges() {
    var n = ids().length;
    document.querySelectorAll('[data-mcw-fav-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      var bubble = el.closest('[data-mcw-fav-bubble]');
      if (bubble) bubble.hidden = n <= 0;
    });
  }
  function fmt(n) { return n >= 1000 ? (Math.round(n / 100) / 10) + 'k' : String(n); }
  function render(btn) {
    var pid = btn.getAttribute('data-mcw-like');
    var n = counts[pid] || 0, on = !!liked[pid];
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-liked', on);
    var el = btn.querySelector('[data-mcw-like-n]');
    if (el) { el.textContent = n > 0 ? fmt(n) : ''; el.hidden = n <= 0; }
    btn.setAttribute('aria-label', (on ? 'Remove from favorites' : 'Save to favorites') + (n > 0 ? ' (' + n + ' likes)' : ''));
    btn.title = on ? 'Saved to your favorites' : 'Save to favorites';
  }
  function renderAll(root) { (root || document).querySelectorAll('[data-mcw-like]').forEach(render); updateBadges(); }
  function track(name, props) { try { if (typeof window.plausible === 'function') window.plausible(name, { props: props }); } catch (e) {} }

  // ---- toast ("Saved to your favorites · View all") -------------------------------------------------
  var toastTimer;
  function toast(n) {
    var t = document.getElementById('mcw-fav-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'mcw-fav-toast';
      t.setAttribute('role', 'status');
      t.innerHTML = '<span class="mcw-fav-toast__text"></span> <a class="mcw-fav-toast__link" href="/pages/my-favorites"></a>';
      document.body.appendChild(t);
    }
    t.querySelector('.mcw-fav-toast__text').textContent = 'Saved to your favorites';
    t.querySelector('.mcw-fav-toast__link').textContent = 'View all (' + n + ')';
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 4500);
  }

  // ---- cross-device sync, Shopify only (owner 2026-10-27: "no external tools") --------------------
  // The list is mirrored into a cart attribute. Shopify keeps the cart of a logged-in customer and restores
  // it on their other devices, so the favorites travel with it. Guests: same device only (cart cookie).
  var ATTR = '_mcw_favorites', pushTimer, lastPushed = null;
  function pushFavs() {
    clearTimeout(pushTimer);
    pushTimer = setTimeout(function () {
      var v = ids().join(',');
      if (v === lastPushed) return;
      lastPushed = v;
      var a = {}; a[ATTR] = v;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: a }) }).catch(function () {});
    }, 600);
  }
  function pullFavs() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var v = (c && c.attributes && c.attributes[ATTR]) || '';
      lastPushed = v;
      var remote = v ? v.split(',').filter(Boolean) : [];
      var before = ids().length;
      remote.forEach(function (p) { liked[String(p)] = 1; });
      if (ids().length !== before) { saveLiked(); renderAll(); }
      if (ids().join(',') !== v) pushFavs(); // local-only favorites -> into the (customer's) cart too
    }).catch(function () {});
  }

  function load() {
    updateBadges();
    pullFavs();
    try {
      var c = JSON.parse(sessionStorage.getItem('mcw_like_counts') || 'null');
      if (c && Date.now() - c.t < 60000) { counts = c.counts || {}; renderAll(); return; }
    } catch (e) {}
    fetch(API + 'mcw-likes', { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (d) {
      counts = (d && d.counts) || {};
      try { sessionStorage.setItem('mcw_like_counts', JSON.stringify({ t: Date.now(), counts: counts })); } catch (e) {}
      renderAll();
    }).catch(function () { renderAll(); });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-mcw-like]');
    if (!btn) return;
    ev.preventDefault(); ev.stopPropagation();
    var pid = btn.getAttribute('data-mcw-like');
    var action = liked[pid] ? 'unlike' : 'like';
    if (action === 'like') { liked[pid] = 1; counts[pid] = (counts[pid] || 0) + 1; }
    else { delete liked[pid]; counts[pid] = Math.max(0, (counts[pid] || 0) - 1); }
    saveLiked();
    try { sessionStorage.removeItem('mcw_like_counts'); } catch (e) {}
    document.querySelectorAll('[data-mcw-like="' + pid + '"]').forEach(render);
    btn.classList.remove('is-pop'); void btn.offsetWidth; if (action === 'like') btn.classList.add('is-pop');
    if (action === 'like' && !btn.closest('[data-mcw-favorites]')) toast(ids().length);
    track('ProductLike', { action: action, product: pid, page: location.pathname });
    pushFavs();
    fetch(API + 'mcw-like', { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ pid: pid, action: action }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.pid === pid && typeof d.count === 'number') {
          counts[pid] = d.count;
          document.querySelectorAll('[data-mcw-like="' + pid + '"]').forEach(render);
        }
      })
      .catch(function () {});
  }, true);

  // another tab changed the favorites
  window.addEventListener('storage', function (e) {
    if (e.key !== 'mcw_liked') return;
    liked = {};
    try { (JSON.parse(e.newValue || '[]') || []).forEach(function (p) { liked[p] = 1; }); } catch (x) {}
    renderAll();
    try { document.dispatchEvent(new CustomEvent('mcw:favs', { detail: { ids: ids() } })); } catch (x) {}
  });

  // product cards appended later (infinite grid, recommendations, quick view)
  if ('MutationObserver' in window) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
        var n = ms[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-mcw-like]') || n.querySelector('[data-mcw-like]'))) renderAll(n.parentNode || n);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
})();
